export default ({
  itemQuantity = null,
  returnComment = '',
  exchangeComment = '',
  returnQuantity = 0,
  returnReasonCodes = null,
  nestedReasons = null,
  selectedReason = null,
  selectedNestedReason = null,
  commentRequired = false,
  commentHidden = false,
  commentPlaceholder = null,
  exchangeOptions = {},
  selectedOptions = {},
  currentInventory = [],
  options = [],
  productQtyOptions = {},
  itemQtyOptions = {},
  inventory = [],
  selectedProduct = null,
  error = false,
  inventoryError = false,
  inventoryUnavailable = false,
  disableSubmit = true,
}) => ({
  itemQuantity,
  returnComment,
  exchangeComment,
  returnQuantity,
  returnReasonCodes,
  nestedReasons,
  selectedReason,
  selectedNestedReason,
  commentRequired,
  commentHidden,
  commentPlaceholder,
  exchangeOptions,
  selectedOptions,
  currentInventory,
  options,
  productQtyOptions,
  itemQtyOptions,
  inventory,
  selectedProduct,
  error,
  inventoryError,
  inventoryUnavailable,
  disableSubmit,
});
